<template>
  <div
    class="odds-checker-table-context-menu"
    :style="{
      top: `${top}px`,
      left: `${left}px`,
    }"
  >
    <div
      class="odds-checker-table-context-menu__action"
      @click="redirectToMapping"
    >
      Mapping
      <Icon
        name="link-external"
        @click.stop="redirectToMapping('_blank')"
      />
    </div>
    <div
      class="odds-checker-table-context-menu__action"
      @click="redirectToPFConfiguration"
    >
      PF Configuration
      <Icon
        name="link-external"
        @click.stop="redirectToPFConfiguration('_blank')"
      />
    </div>
    <div
      class="odds-checker-table-context-menu__action"
      @click="redirectToEventCenter"
    >
      Event Center
      <Icon
        name="link-external"
        @click.stop="redirectToEventCenter('_blank')"
      />
    </div>
    <div
      class="odds-checker-table-context-menu__action"
      @click="redirectToTradingUI"
    >
      Trade Event
      <Icon
        name="link-external"
        @click.stop="redirectToTradingUI('_blank')"
      />
    </div>
    <div
      class="odds-checker-table-context-menu__action"
      @click="redirectToParamsSetup"
    >
      Params Setup
      <Icon
        name="link-external"
        @click.stop="redirectToParamsSetup('_blank')"
      />
    </div>
  </div>
</template>

<script>
import { provide } from 'vue';
import { useRouter } from 'vue-router';
import Icon from '@/components/common/Icon';

export default {
  components: {
    Icon,
  },
  props: {
    top: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    event: {
      type: Object,
      required: true,
    },
  },
  emits: {
    hide: {},
    replay: {},
    updateEvent: {},
  },
  setup(props, { emit }) {
    const router = useRouter();
    provide('isMenuOpen', true);

    const handleNavigation = (routeOptions, target = '') => {
      if (target === '_blank') {
        const url = router.resolve(routeOptions).href;
        window.open(url, target);
      } else {
        router.push(routeOptions);
      }
      emit('hide');
    };

    const redirectToMapping = (target = '') => {
      handleNavigation({
        name: 'eventsMapping',
        query: { sport: props.event?.sportId },
      }, target);
    };

    const redirectToPFConfiguration = (target = '') => {
      handleNavigation({
        name: 'weights-configuration',
        query: {
          sport: props.event?.sportId,
          competition: props.event?.competitionId,
        },
      }, target);
    };

    const redirectToEventCenter = (target = '') => {
      handleNavigation({
        name: 'events',
        query: {
          sport: props.event?.sportId,
          competition: props.event?.competitionId,
        },
      }, target);
    };

    const redirectToParamsSetup = (target = '') => {
      handleNavigation({
        name: 'params-setup',
        params: { eventId: props.event?.eventId },
      }, target);
    };

    const redirectToTradingUI = (target = '') => {
      handleNavigation({
        name: 'trading-ui',
        params: { eventId: props.event?.eventId },
      }, target);
    };

    return {
      redirectToParamsSetup,
      redirectToMapping,
      redirectToPFConfiguration,
      redirectToEventCenter,
      redirectToTradingUI,
    };
  },
};
</script>

  <style lang="scss">
  .odds-checker-table-context-menu {
    display: flex;
    flex-direction: column;
    position: fixed;
    background-color: $white;
    color: $black;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    border: 1px solid rgba(221, 221, 221, 1);
    z-index: $dropdownMenuZIndex;

    &__action {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      gap:8px;
      white-space: nowrap;
      min-width: 100%;
      height: 44px;
      padding: 0 12px;
      box-shadow: inset 0px -1px 0px #F0F0F0;
      cursor: pointer;

      .spinner {
        width: 100%;
        justify-content: center;
      }

      &:last-of-type {
        box-shadow: none;
      }

      &:hover,
      &:focus {
        background-color: #FAFAFA;
        outline: none;
      }

      &.warning {
        color: #FF2E2D;
      }
    }
  }
  </style>
